import { api } from '@services';

import Contact, { IContact, IContactApiModel } from '@models/Contact.model';

interface INewContact {
  contactId: string;
  manufacturerId?: string;
  name?: string;
  title?: string;
  isGlobal?: boolean;
  emails?: Array<{ email: string; label: string }>;
  phones?: Array<{ phone: string; label: string }>;
  favorite?: boolean;
}
interface IManufacturerVariables {
  data: INewContact;
}

const changeContact = async ({
  data: { contactId, ...data },
}: IManufacturerVariables): Promise<IContact> => {
  const { data: contact } = await api.patch<IContactApiModel>(
    `/contacts/${contactId}`,
    data,
  );

  return Contact.fromApiModel(contact);
};

export { changeContact };
